import React from 'react';
import { translation } from 'js-utils/prop-types';
import { getWindowObject } from '@eb/feature-detection';

export default class PageTitle extends React.PureComponent {
    static propTypes = {
        title: translation.isRequired,
    };

    componentDidMount() {
        this.updateTitle();
    }

    componentDidUpdate() {
        this.updateTitle();
    }

    updateTitle = () => {
        const document = getWindowObject('document');

        if (document) {
            document.title = this.props.title;
        }
    };

    render() {
        return null;
    }
}
